<t4-header icon="settings_b_roll">
</t4-header>
<t4-container title="{{ 'Turbo.Settings.Addons.spareparts' | translate : 'Spareparts' }}">

  <t4-data-table #sparepartsList [rawData]="mySpareParts" headline="" matSort [allowPaging]="true" [allowFilter]="false" [allowAdd]="true" [autoGenerateColumns]="false" (addClicked)="openAddon(null, false)">

    <ng-container matColumnDef="Id" sticky>
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
        <button mat-icon-button (click)="openAddon(row, false)">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Title">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.ManagePricelists.colTitle' | translate : 'Title' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.Title }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Description">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.ManagePricelists.colDescription' | translate : 'Description' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.Description }}</mat-cell>
    </ng-container>


    <ng-container matColumnDef="Delete" stickyEnd>
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
        <button mat-icon-button (click)="deleteAddon(row)" *ngIf="!row.IsActive">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
  <t4-container title="{{ 'Turbo.Settings.SpareParts.lblInherited' | translate : 'Inherited' }}">
    <t4-data-table #inherited [rawData]="inheritedSpareParts" headline="" matSort [allowPaging]="false" [allowFilter]="false" [allowAdd]="false" [autoGenerateColumns]="false">
      <ng-container matColumnDef="Id">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          <button mat-icon-button (click)="openAddon(row, true)">
            <mat-icon>open_in_new</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Title">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.ManagePricelists.colTitle' | translate : 'Title' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.Title }}</mat-cell>
      </ng-container>
    </t4-data-table>

  </t4-container>
